import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const fieldStyle = { width:'100%', boxSizing:'border-box', marginTop:7, border:'1.5px solid #E3E8F1', borderRadius:11, padding:'13px 14px', fontFamily:'Inter,sans-serif', fontSize:14, color:'#0D1B2A' };
const labelStyle = { display:'block', marginTop:16, color:'#5B6B85', fontFamily:'Inter,sans-serif', fontSize:12, fontWeight:600 };

export default function Register() {
  const navigate = useNavigate();
  const [shopName, setShopName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    if (password !== confirmation) { setError('Passwords do not match.'); return; }
    setBusy(true);
    setError('');
    try {
      const response = await fetch('/api/account/register', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'X-ShopkeeperIQ-Client':'1' },
        body:JSON.stringify({ email:email.trim(), password, shopName:shopName.trim() }),
      });
      if (!response.ok) {
        if (response.status === 404) { setError('Registration is currently unavailable. Contact your ShopkeeperIQ administrator.'); return; }
        const body = await response.json().catch(() => ({}));
        const validation = Object.values(body.errors || {}).flat();
        setError(validation[0] || body.detail || body.title || 'Could not create your account.');
        return;
      }
      navigate('/settings', { replace:true });
    } catch {
      setError('Could not reach ShopkeeperIQ. Check your connection and try again.');
    } finally {
      setBusy(false);
    }
  }

  return <div data-screen-label="Register" style={{minHeight:'100dvh',background:'#F4F6FB',fontFamily:'Inter,sans-serif'}}>
    <div style={{background:'#0D1B2A',padding:'30px 24px 48px',color:'#fff'}}>
      <div style={{fontFamily:'Poppins,sans-serif',fontSize:25,fontWeight:700}}>Shopkeeper<span style={{color:'#5B86FF'}}>IQ</span></div>
      <h1 style={{fontFamily:'Poppins,sans-serif',fontSize:23,margin:'24px 0 4px'}}>Create your account</h1>
      <p style={{fontSize:13,color:'#B8C6DA',margin:0}}>Set up your shop, then connect its Windows driver.</p>
    </div>
    <form onSubmit={submit} style={{background:'#fff',borderRadius:'24px 24px 0 0',marginTop:-22,padding:'16px 24px 32px',minHeight:'calc(100dvh - 165px)'}}>
      <label style={labelStyle}>Shop name<input required maxLength={120} autoComplete="organization" value={shopName} onChange={event=>setShopName(event.target.value)} placeholder="Your shop" style={fieldStyle}/></label>
      <label style={labelStyle}>Email<input required type="email" autoComplete="email" value={email} onChange={event=>setEmail(event.target.value)} placeholder="you@yourshop.co.uk" style={fieldStyle}/></label>
      <label style={labelStyle}>Password<input required type="password" autoComplete="new-password" minLength={10} value={password} onChange={event=>setPassword(event.target.value)} style={fieldStyle}/></label>
      <div style={{fontSize:11,color:'#6B7894',marginTop:6}}>At least 10 characters, including uppercase, lowercase, and a number.</div>
      <label style={labelStyle}>Confirm password<input required type="password" autoComplete="new-password" value={confirmation} onChange={event=>setConfirmation(event.target.value)} style={fieldStyle}/></label>
      {error && <div role="alert" style={{color:'#D6453F',fontSize:12,marginTop:14,lineHeight:1.5}}>{error}</div>}
      <button type="submit" disabled={busy} style={{width:'100%',marginTop:22,padding:15,border:0,borderRadius:13,background:busy?'#9AAEEA':'#1B4DE4',color:'#fff',fontSize:15,fontWeight:700,cursor:busy?'default':'pointer'}}>{busy?'Creating account…':'Create account'}</button>
      <div style={{textAlign:'center',fontSize:13,marginTop:20,color:'#5B6B85'}}>Already have an account? <Link to="/login" style={{color:'#1B4DE4',fontWeight:700}}>Sign in</Link></div>
    </form>
  </div>;
}
